module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/Beer-59d0ab8bd0548d75a7a8fc9649e55963.svg";